export const getPluralLabel = (label?: string) => {
  if (!label) return 'items';
  const trimmed = label.trim();
  const parts = trimmed.split(/\s+/);
  const lastWord = parts[parts.length - 1] || '';

  // For multi-word labels already ending in a plural noun (e.g. "Tag Associations"),
  // keep as-is.
  if (
    parts.length > 1 &&
    /(ies|[sxz]es|ches|shes|s)$/i.test(lastWord)
  ) {
    return trimmed;
  }

  if (/(s|x|z|ch|sh)$/i.test(lastWord)) return `${trimmed}es`;
  if (lastWord.endsWith('y')) {
    const beforeY = lastWord[lastWord.length - 2];
    if (beforeY && /[aeiou]/i.test(beforeY)) return `${trimmed}s`;
    return `${trimmed.slice(0, -1)}ies`;
  }
  return `${trimmed}s`;
};
